/* eslint-disable max-len */
/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { Input } from '../../Input/Input';

const TextTypeComponent = ({
  item,
  value,
  textInputHandler,
  wd,
  placeholder,
  initialFormInput,
  formInput
}) => {
  const {
    key,
    isReadOnly,
    inputType,
    allowEmpty,
    placeholder: itemPlaceholder
  } = item;

  return (
    <>
      <Input
        type={inputType}
        placeholder={placeholder || itemPlaceholder || ''}
        name='name'
        onChange={(e) => textInputHandler(e, key)}
        value={value}
        width={wd}
        readOnly={!allowEmpty && !initialFormInput?.[key] ? false : isReadOnly}
        maxLength={item?.maxLength}
        max={item?.maxValue && item?.maxValue}
        min={item?.minValue && item?.minValue}
      />
    </>
  );
};
export default TextTypeComponent;
